import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', bgcolor: '#0c0a18', color: '#e8e4f8', gap: 2, p: 4,
        }}>
          <ErrorOutlineIcon sx={{ fontSize: 48, color: '#f87171' }} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Something went wrong
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(232,228,248,0.5)', maxWidth: 400, textAlign: 'center' }}>
            The dashboard encountered an unexpected error. Try reloading the page.
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <Button variant="contained" onClick={() => window.location.reload()}
              sx={{ bgcolor: '#c85448', '&:hover': { bgcolor: '#b8473c' } }}>
              Reload Page
            </Button>
            <Button variant="outlined" onClick={this.handleReset}
              sx={{ borderColor: 'rgba(255,255,255,0.2)', color: '#e8e4f8',
                    '&:hover': { borderColor: 'rgba(255,255,255,0.4)' } }}>
              Try Again
            </Button>
          </Box>
          {this.state.error && (
            <Typography variant="caption" sx={{
              mt: 2, color: 'rgba(232,228,248,0.25)', fontFamily: 'monospace',
              maxWidth: 500, textAlign: 'center', wordBreak: 'break-word',
            }}>
              {this.state.error.toString()}
            </Typography>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
